export default function CustomEvent({ event, currentView }) {
  if (currentView === "month") return null;
  return <span>{event.title}</span>;
}
